import { useFetchNew } from '../../data/fetch/useFetch';
import { parseMatchDataMacrogruppo } from '../../data/parseMatchDataMacrogruppo';
import { getConfiguration } from '../../data/utils';
import Loader from '../../common/Loader';

export default function EventFetcher(props) {
    const conf = getConfiguration();
    const event = props.data;
    const macroId = props.macroId || -1 * event.sportRef;
    
    const [isLoading, isError, data] = useFetchNew(conf.api.getEventoPerMacrogruppo, {
        pal: event.pal,
        avv: event.avv,
        idMacrogruppo: macroId,
        isLive: false
    }, (data) =>
        parseMatchDataMacrogruppo(data, macroId, event, false, true)
    );

    if (isLoading || isError) {
        return <Loader error={isError} />;
    }

    return props.renderItem(data || {});
}
